import { useTranslation } from "react-i18next";
import {
  FormSection,
  FormSectionStack,
  NumberField,
} from "@/features/admin/components";

/**
 * Paso 7 · Envío: peso y medidas, y nada más.
 *
 * ── Vuelve como paso propio (Anahí, 21-sep-2026) ────────────────────
 * El 26-ago salió de Variantes ("ese paso lleva las variantes y los
 * costos, nada más") y se quedó sin control: el dato viajaba pero nadie
 * podía escribirlo. Con la llave de Trasso puesta, las guías se piden en
 * automático desde estos cuatro números, así que ahora sí tienen que
 * poderse capturar. Anahí eligió un paso nuevo antes que meterlos en
 * Clasificación, para no tocar lo que dictó para los otros siete.
 *
 * ── Los cuatro son OPCIONALES ───────────────────────────────────────
 * Un hueco lo llena el estándar de la casa —la caja de un frasco: 500 g,
 * 15×10×10— campo por campo (`shippingOf`, en el contrato). Ninguna
 * ficha incompleta detiene un envío; una ficha completa lo cobra bien.
 *
 * ── Gramos y centímetros ────────────────────────────────────────────
 * Trasso pide kilos con decimales; aquí se escriben GRAMOS enteros y la
 * conversión la hace el servidor. Es más fácil teclear 350 que 0.35, y
 * un entero no admite el error de un punto mal puesto.
 */
export function ShippingStep() {
  const { t } = useTranslation();

  return (
    <FormSectionStack>
      <FormSection
        title={t("Envío")}
        description={t(
          "Lo que pesa y mide el producto ya empacado. Con esto se pide la guía sin que nadie lo teclee al enviar; lo que falte usa la caja estándar de un frasco.",
        )}
        columns={4}
        compact
      >
        <NumberField
          name="shipping.weightGrams"
          label={t("Peso (g)")}
          placeholder="500"
          hint={t("Gramos enteros.")}
        />
        <NumberField
          name="shipping.lengthCm"
          label={t("Largo (cm)")}
          placeholder="15"
          inputMode="decimal"
        />
        <NumberField
          name="shipping.widthCm"
          label={t("Ancho (cm)")}
          placeholder="10"
          inputMode="decimal"
        />
        <NumberField
          name="shipping.heightCm"
          label={t("Alto (cm)")}
          placeholder="10"
          inputMode="decimal"
        />
      </FormSection>
    </FormSectionStack>
  );
}
